/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { useReducer } from "react";
import "./style.css";

export const FtbAnima = ({ property1, className, vector = "/img/vector-58.png" }) => {
  const [state, dispatch] = useReducer(reducer, {
    property1: property1 || "default",
  });

  return (
    <div
      className={`FTB-anima property-1-${state.property1} ${className}`}
      onClick={() => {
        dispatch("click");
      }}
    >
      <div className="text-wrapper-3">Free Trial</div>
      <img className="vector" alt="Vector" src={vector} />
    </div>
  );
};

function reducer(state, action) {
  switch (action) {
    case "click":
      return {
        ...state,
        property1: "variant-2",
      };
  }

  return state;
}

FtbAnima.propTypes = {
  property1: PropTypes.oneOf(["variant-2", "default"]),
  vector: PropTypes.string,
};
